import React from 'react';

import { Text } from '@/components-new/text';

export const MonospaceText = ({ children }: { children: React.ReactNode }) => {
  return <Text className="font-mono">{children}</Text>;
};
